"use strict";

exports.__esModule = true;
exports.default = void 0;

var zeroPad = function zeroPad(n) {
  return n.toString().padStart(2, '0');
};

var durationToTimeString = function durationToTimeString(duration) {
  if (!duration) {
    return '';
  }

  return zeroPad(duration.hours) + ":" + zeroPad(duration.minutes);
};

var _default = durationToTimeString;
exports.default = _default;